// extracted by mini-css-extract-plugin
export default {"root":"blog-entry-layout-content_root__sy9n-"};